import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { SITE } from "../data/content";

export default function Footer() {
    return (
        <footer
            className="bg-[#EFEBE4] text-[#4A4947] mt-24 border-t border-[#e3ddd1]"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    {/* Brand */}
                    <div className="lg:col-span-5">
                        <Link to="/" className="flex items-baseline gap-2">
                            <span className="font-serif text-3xl tracking-tight text-[#2C2B29]">
                                Soul Sync
                            </span>
                            <span className="font-serif text-3xl italic text-[#A68A6B] tracking-tight">
                                Healing
                            </span>
                        </Link>
                        <p className="mt-6 max-w-md text-base leading-relaxed text-[#4A4947]">
                            A safe, grounded space where modern psychology meets
                            soul-rooted healing. Hypnotherapy, breathwork,
                            constellation work, and feminine wellness with
                            Shreya.
                        </p>
                        <div className="mt-8 flex items-center gap-5">
                            <a
                                href={`mailto:${SITE.email}`}
                                aria-label="Email Soul Sync Healing"
                                className="text-[#4A4947] hover:text-[#A68A6B] transition-colors"
                                data-testid="footer-email"
                            >
                                <Mail className="h-5 w-5" strokeWidth={1.5} />
                            </a>
                            <a
                                href={`https://wa.me/${SITE.whatsappRaw}`}
                                target="_blank"
                                rel="noreferrer"
                                aria-label="WhatsApp"
                                className="text-[#4A4947] hover:text-[#A68A6B] transition-colors"
                                data-testid="footer-whatsapp"
                            >
                                <MessageCircle
                                    className="h-5 w-5"
                                    strokeWidth={1.5}
                                />
                            </a>
                            <a
                                href={SITE.instagramUrl}
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Instagram"
                                className="text-[#4A4947] hover:text-[#A68A6B] transition-colors"
                                data-testid="footer-instagram"
                            >
                                <Instagram
                                    className="h-5 w-5"
                                    strokeWidth={1.5}
                                />
                            </a>
                        </div>
                    </div>

                    {/* Explore */}
                    <div className="lg:col-span-3">
                        <p className="ssh-eyebrow">Explore</p>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li>
                                <Link
                                    to="/about"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    About Shreya
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/services"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/packages"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    Signature Packages
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/shop"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    Shop
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/corporate"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    Corporate Wellness
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/blog"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    Insights
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Connect */}
                    <div className="lg:col-span-4">
                        <p className="ssh-eyebrow">Connect</p>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li>
                                <a
                                    href={`mailto:${SITE.email}`}
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    {SITE.email}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`https://wa.me/${SITE.whatsappRaw}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    WhatsApp · {SITE.whatsappDisplay}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={SITE.instagramUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    Instagram · {SITE.instagramHandle}
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    className="hover:text-[#A68A6B] transition-colors"
                                >
                                    Begin Your Healing Journey →
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-[#dfd9cc] flex flex-col lg:flex-row gap-6 justify-between text-xs text-[#75736F]">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
                        <p>
                            © {new Date().getFullYear()} Soul Sync Healing. All
                            rights reserved.
                        </p>
                        <Link
                            to="/privacy"
                            className="hover:text-[#A68A6B] transition-colors"
                            data-testid="footer-privacy"
                        >
                            Privacy Policy
                        </Link>
                    </div>
                    <p className="max-w-xl lg:text-right leading-relaxed">
                        Disclaimer: Soul Sync Healing offerings are
                        complementary and do not replace medical, psychiatric,
                        or psychological treatment. Please consult a licensed
                        professional for medical concerns.
                    </p>
                </div>
            </div>
        </footer>
    );
}
